import React, { Component } from 'react';
import {http, baseURL} from '../misc/http';
import Layout from '../layout/Main';
import Header from '../components/ProfileOrganizer/Header';
import About from '../components/ProfileOrganizer/About';
import Memberships from '../components/ProfileOrganizer/Memberships';
import MediaNAchievMent from '../components/ProfileOrganizer/MediaNAchievment';
import Location from '../components/ProfileOrganizer/Location';

export default class ProfileOrganizer extends Component {
  state = {
    profile: {},
    detilProfile: {},
    detilNews: []
  }

  componentDidMount = () => {
    const {id} = this.props.match.params;
    this.handleGetProfile(id);
    this.handleGetDetilProfile(id);
    this.handleGetDetilNews(id);
  }

  handleGetProfile = async (id) => {
    let params = {
      method:'GET',
      path:'organizer/'+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {profile} = this.state;
      profile = data.data;
      this.setState({profile});
      
    }
  }

  handleGetDetilProfile = async (id) => {
    let params = {
      method:'GET',
      path:'organizer/detil/'+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {detilProfile} = this.state;
      detilProfile = data.data;
      this.setState({detilProfile})
    }
  }

  handleGetDetilNews = async (id) => {
    let params = {
      method:'GET',
      path:'organizer/detil/news/'+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {detilNews} = this.state;
      detilNews = data.data;
      this.setState({detilNews})
    }
  }

  render() {
    return (
      <Layout>
        <Header organizer={{...this.state.profile, ...this.state.detilProfile}} baseURL={baseURL}/>
        <About organizer={this.state.detilProfile}/>
        <Memberships organizer={{...this.state.profile, ...this.state.detilProfile}} baseURL={baseURL}/>
        <MediaNAchievMent organizer={{...this.state.profile, ...this.state.detilProfile, news: this.state.detilNews}} baseURL={baseURL}/>
        <Location organizer={this.state.detilProfile}/>
      </Layout>
    )
  }
}
